<template>
  <div class="admin-shell min-h-screen bg-bochas-bg text-white">
    <header
      class="sticky top-0 z-40 border-b border-white/10 bg-[#0a0e1a]/95 backdrop-blur-xl"
    >
      <div
        class="mx-auto flex max-w-7xl flex-col gap-3 px-4 pb-3 pt-[calc(0.875rem+var(--safe-top))] sm:py-6 sm:px-6 lg:px-0"
      >
        <div class="flex min-w-0 items-center justify-between gap-4">
          <router-link to="/admin" class="flex min-w-0 items-center gap-3">
            <img
              src="@/assets/images/logoFederacion.png"
              alt="Federación de Bochas Córdoba"
              class="h-10 w-10 flex-shrink-0 object-contain sm:h-11 sm:w-11"
            />
            <div class="min-w-0">
              <p
                class="truncate text-[11px] font-semibold uppercase text-bochas-rojo sm:text-xs"
              >
                Panel de administración
              </p>
              <h1
                class="truncate text-base font-bold leading-tight text-white sm:text-lg"
              >
                Federación de Bochas Córdoba
              </h1>
            </div>
          </router-link>

          <div class="flex flex-shrink-0 items-center gap-2">
            <div class="hidden text-right md:block">
              <p class="text-sm font-semibold text-white">
                {{ userName }}
              </p>
              <p class="text-xs text-bochas-text-muted">
                {{ user?.email || "Sesión activa" }}
              </p>
            </div>
            <button
              type="button"
              class="admin-shell__logout"
              aria-label="Cerrar sesión"
              title="Cerrar sesión"
              @click="onLogout"
            >
              <IconFbochas name="log-out" :size="18" />
            </button>
          </div>
        </div>
      </div>
    </header>

    <main class="admin-shell__content">
      <slot />
    </main>

    <!-- Quick Actions dock — presente en TODAS las vistas admin -->
    <AdminQuickActions />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import IconFbochas from "@/components/Icons/IconFbochas.vue";
import AdminQuickActions from "../../components/Admin/AdminQuickActions.vue";
import { getMe, getStoredUser, logout } from "@/services/auth/authService";

const router = useRouter();
const user = ref(getStoredUser());

const userName = computed(() => {
  if (!user.value) return "Administrador";
  const fullName = [user.value.firstname, user.value.lastname]
    .filter(Boolean)
    .join(" ");
  return fullName || "Administrador";
});

function onLogout() {
  logout();
  router.replace("/login");
}

onMounted(async () => {
  const fresh = await getMe();
  if (fresh) user.value = fresh;
});
</script>

<style scoped>
.admin-shell__logout {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  transition: background-color 180ms ease, border-color 180ms ease,
    color 180ms ease, transform 180ms ease;
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 9999px;
}

.admin-shell__logout:hover {
  border-color: rgba(165, 33, 33, 0.45);
  background: rgba(165, 33, 33, 0.16);
  color: white;
  transform: translateY(-1px);
}

.admin-shell__content {
  min-height: calc(100vh - 5.75rem);
  padding-bottom: 5.5rem; /* espacio para el dock fijo */
}

.admin-shell__content :deep(.min-h-screen.bg-bochas-bg) {
  min-height: auto;
  background: transparent;
}

@media (prefers-reduced-motion: reduce) {
  .admin-shell__nav-link,
  .admin-shell__logout {
    transition: none;
  }

  .admin-shell__nav-link:hover,
  .admin-shell__logout:hover {
    transform: none;
  }
}
</style>
